<template>
    <div>
        <div class="absolute -mt-1 md:-mt-8 pl-1 md:pl-3">
            <i class="text-sm text-green-warm-500 fas fa-equals"></i>
        </div>

        <form-row title="Balance Earnest Money"
            section_id="earnest-money"
            :no_border="true"
            class="mt-6 md:-mt-2 mb-6"
            label_class="ml-8 md:ml-0"
        >
            <div class="w-full sm:w-36 mt-4 sm:mr-4 sm:my-2">
                <input-money
                    label="Amount Due"
                    name="balance_earnest_money"
                    :value="balance_amount"
                    :read_only="true"
                    tabindex="-1"
                />
            </div>

            <div class="w-full sm:w-auto sm:mr-4 mt-4 sm:my-2">
                <input-date
                    label="Date Due"
                    name="balance_earnest_date_due"
                    v-model="balance_earnest_date_due"
                    @entered="dateEntered"
                    :read_only="read_only"
                />
            </div>

            <div class="flex items-end w-full sm:w-auto mt-4 sm:my-2">
                <span class="text-sm text-gray-600 sm:pl-1 pr-3 mb-3">
                    OR
                </span>

                <div class="w-16">
                    <input-text
                        name="balance_earnest_days_after"
                        v-model="balance_earnest_days_after"
                        :read_only="read_only"
                    />
                </div>

                <span class="text-sm text-gray-600 leading-tight pl-2 -mr-4">
                    {{ $t('days after') }} <br>{{ $t('Attorney Review') }}
                </span>
            </div>
        </form-row>

        <form-row
            :no_border="true"
            class="-mt-12 md:-mt-2 mb-6"
            label_class="ml-8 md:ml-0"
        >
            <div class="hidden xs:block sm:w-36 mt-4 sm:mr-4 sm:my-1">
                <!--  -->
            </div>

            <div class="w-full sm:w-auto sm:mr-4 mt-4 sm:my-1">
                <input-date
                    label="Date Received"
                    name="balance_earnest_date_received"
                    :value="balance_date_received"
                    @input="$emit('updateDateRecieved', $event)"
                    :read_only="read_only"
                />
            </div>

            <div class="sm:w-auto mt-4 sm:mr-4 sm:my-2">
                <input-radio-boolean
                    class="flex flex-col justify-between h-16"
                    label="Receipt Issued?"
                    name="balance_earnest_receipt"
                    v-model="receipt_issued"
                    true="Yes"
                    false="No"
                    :reverse="true"
                    :read_only="read_only"
                />
            </div>
        </form-row>

        <form-row
            v-if="receipt_issued"
            :no_border="true"
            class="-mt-12 md:-mt-2 mb-6"
            label_class="ml-8 md:ml-0"
        >
            <div class="hidden xs:block sm:w-36 mt-4 sm:mr-4 sm:my-1">
                <!--  -->
            </div>

            <div class="w-full sm:w-auto sm:mr-4 mt-4 sm:my-1">
                <input-date
                    label="Receipt Issue Date"
                    name="balance_earnest_receipt_date"
                    :value="deal.balance_earnest_receipt_date"
                    :read_only="read_only"
                />
            </div>

            <div class="sm:w-auto mt-4 sm:mr-4 sm:my-2">
                <!--  -->
            </div>
        </form-row>

        <div class="border-b border-gray-400 md:ml-46 mb-6"></div>
    </div>
</template>

<script>
import DateFunctions from '../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        deal: { default: () => ({}) },
        balance_amount: {},
        balance_date_received: {},
        read_only: { default: false },
    },

    data() {
        return {
            receipt_issued: this.deal.balance_earnest_receipt,
            balance_earnest_date_due: this.deal.balance_earnest_date_due,
            balance_earnest_days_after: this.deal.balance_earnest_days_after,
        }
    },

    computed: {
        attorney_review_date() {
            return store.state.attorney_review_date;
        },
        balance_earnest_date_due_from_period() {
            if (! this.attorney_review_date) {
                return;
            }

            if (this.isValidDate(this.attorney_review_date) && this.balance_earnest_days_after) {
                return dayjs(this.attorney_review_date.slice(0, 10))
                    .add({ day: this.balance_earnest_days_after })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        dateEntered() {
            this.balance_earnest_days_after = null;
        },
    },

    watch: {
        balance_earnest_date_due_from_period(val) {
            if (val) {
                this.balance_earnest_date_due = val;
            }
        },
    },
}
</script>
